/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Approve_Effect_NowInputs */



/**
* | output |
* | --- |
* | "Its start date has been reached, so the organization becomes active the moment you approve, its prepaid budget is credited now, and its administrator is emai..." |
*
* @param {Partner_Org_Contract_Approve_Effect_NowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approve_effect_now = /** @type {((inputs?: Partner_Org_Contract_Approve_Effect_NowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approve_Effect_NowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Startdatum ist erreicht. Die Organisation wird daher sofort mit der Freigabe aktiv, das vorausbezahlte Guthaben wird jetzt gutgeschrieben und die Administration per E-Mail eingeladen. Die Freigabe kann danach nicht mehr zurückgezogen werden.")
	return /** @type {LocalizedString} */ ("Its start date has been reached, so the organization becomes active the moment you approve, its prepaid budget is credited now, and its administrator is emailed an invitation. This approval can then no longer be withdrawn.")
});